import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/microphone.png'


const _withScopeId = n => (_pushScopeId("data-v-01fdd318"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Loading..", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content-wrapper"
}
const _hoisted_6 = { class: "info-header" }
const _hoisted_7 = { class: "score-section" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Score: ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Failed: ")
const _hoisted_10 = { class: "time-section" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Remaning Time: ")
const _hoisted_12 = { class: "count-text" }
const _hoisted_13 = { class: "interactive-section" }
const _hoisted_14 = { class: "text-wrapper" }
const _hoisted_15 = { class: "interactive-text" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "button-wrapper" }
const _hoisted_18 = {
  key: 1,
  class: "mic-wrapper"
}
const _hoisted_19 = {
  key: 1,
  class: "loading-spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isReady === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(_ctx.score), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(_ctx.failedScore), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, "00:0" + _toDisplayString(_ctx.countDown), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h1", _hoisted_15, "Word:" + _toDisplayString(_ctx.questionWord), 1),
              _createElementVNode("h3", {
                class: "interactive-text",
                ref: "answerText"
              }, " Your Answer: " + _toDisplayString(_ctx.text), 513),
              (_ctx.matchedList.synonym && !_ctx.isAnswerCorrect && this.text)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Synonyms:" + _toDisplayString(_ctx.matchedList.synonym.slice(0, 5).join()), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.countDown > 0 && _ctx.isReady === null && !_ctx.inProgress)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.getRandomWord()), ["prevent"])),
                    class: "random-button"
                  }, " Get Random Word "))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (!_ctx.inProgress)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _imports_0,
                          alt: "microphone",
                          class: "mic-icon",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => {
                !_ctx.text ? _ctx.speak() : '';
                !_ctx.text ? (_ctx.inProgress = true) : '';
              })
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19))
                  ])),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.getRandomWord()), ["prevent"])),
                class: "random-button"
              }, " Next Please ")
            ])
          ])
        ]))
  ]))
}